import { useMedia } from "dsl/atoms/ResponsiveMedia";
import { FileUploadModalProps } from "dsl/organisms/Modals/FileUploadModal";

export function FileUploadScreen({
  closeModal,
  handleSubmit,
  initialValues,
  isOpen,
  mutationProgress,
  setAction,
}: FileUploadModalProps) {
  const { isMobile } = useMedia();

  console.log("FileUploadScreen", {
    closeModal,
    handleSubmit,
    initialValues,
    isMobile,
    isOpen,
    mutationProgress,
    setAction,
  });

  if (!isOpen || !initialValues.fileName) return null;

  return <>TODO: File Upload Screen</>;
}
